import { render } from "./action.vue?vue&type=template&id=c9951d16"
import script from "./action.vue?vue&type=script&lang=js"
export * from "./action.vue?vue&type=script&lang=js"

import "./action.vue?vue&type=style&index=0&id=c9951d16&lang=scss"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__